import getIsSearchTableShown from './getIsSearchTableShown';
import isReadingPaneVisible from 'owa-mail-store/lib/store/selectors/isReadingPaneVisible';
import { getFolderName } from '../selectors/getFolderName';
import { getListViewTypeCustomData } from '../selectors/getListViewTypeCustomData';
import { SourceViewType } from 'owa-mail-store/lib/store/schema/SourceViewType';

/**
 * Returns custom data to be used as telemetry for mail actions
 */
export default function getMailActionCustomData() {
    const { ReadingPane, ListView } = SourceViewType;

    return {
        search: getIsSearchTableShown(),
        folder: getFolderName(),
        ...getListViewTypeCustomData(),
        sourceView: isReadingPaneVisible() ? ReadingPane : ListView,
    };
}
